import { emailValidationRegex, beneficiaryNameRegex, phoneNumberValidationRegex } from "../app_methods";
import { get, post, put } from "../services/HttpService";
import { axiosIns } from "../services";


export class PayoutLink {
    constructor(payoutLinkObject = {}) {
        this.set(payoutLinkObject);
    };

    static validations = {
        "id": [],
        "created_at": [],
        "unique_code": [
            { required: true, message: "Unique Code is required." },
            { pattern: '^[A-Za-z0-9-]+$', message: "Please enter a valid Unique Code." },
            { min: 5, message: "Must be atleast 5 characters long" },
            { max: 32, message: "Can be of maximum 32 characters" }
        ],
        "amount": [
            { required: true, message: "Amount is required." },
            { pattern: '^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$', message: "Please enter a valid amount." }
        ],
        "payee_name": [
            { required: true, message: "Payee Name is required." },
            { pattern: beneficiaryNameRegex(), message: "Please enter a valid name." },
            { min: 1, message: "Must be atleast 1 characters long" },
            { max: 100, message: "Can be of maximum 100 characters" }
        ],
        "payee_email": [
            { pattern: emailValidationRegex(), message: "Please enter a valid Email ID." },
            { min: 1, message: "Must be atlest 1 characters long" },
            { max: 150, message: "Can be of maximum 100 characters" }
        ],
        "payee_phone": [
            { pattern: phoneNumberValidationRegex(), message: "Please enter a valid phone number." }
        ],
        // "skip_authentication": [],
        "allowed_beneficiary_types": [],
        "expiry_date": [],
        "description": [
            { max: 255, message: "Can be of maximum 255 characters" }
        ]
    };

    /**
     * @memberof PayoutLink
     * @type API
     * @returns Promise
     */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/internal/payout_links/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    /**
     * @memberof PayoutLink
     * @type API
     * @returns Promise
     */
        static list_v2 = (queryData = {}, config = {}) => {
            return get(`v2/internal/payout_links/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
        };

    /**
     * @memberof PayoutLink
     * @type API
     * @returns Promise
     */
    save = () => {
        let queryData = this.get();
        if (queryData.expiry_date) queryData.expiry_date = queryData.expiry_date.format("YYYY-MM-DD");
        if (queryData.id) return put(`v1/internal/payout_links/${this.id}/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
        return post(`v1/internal/payout_links/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof PayoutLink
     * @type API
     * @returns Promise
     */
    deactivate = (queryData = {}) => {
        return post(`v1/internal/payout_links/${this.id}/deactivate/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof PayoutLink
     * @type API
     * @returns Promise
     */
    fetchAttempts = (queryData = {}) => {
        return get(`v1/internal/payout_links/${this.id}/attempts/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    static downloadReport = (queryData = {}, config = {}) => {
        return axiosIns
          .request({
            url: `v1/internal/payout_links/download_report/`,
            method: "GET",
            responseType: "blob",
            params: queryData,
            headers: config,
          })
          .catch((error) => ({
            success: false,
            data: (error.response && error.response.data) || {},
            status: (error.response && error.response.status) || 400,
          }));
      };

    /**
     * @memberof PayoutLink
     * @type Getter Method
     * @takes void
     * @returns PayoutLink Params
     */
    get = () => {
        return {
            id: this.id,
            merchant: this.merchant,
            unique_code: this.unique_code,
            status: this.status,
            amount: this.amount,
            description: this.description,
            source: this.source,
            payee_name: this.payee_name,
            payee_email: this.payee_email,
            payee_phone: this.payee_phone,
            // skip_authentication: this.skip_authentication,
            // authentication_key: this.authentication_key,
            allowed_beneficiary_types: this.allowed_beneficiary_types,
            expiry_date: this.expiry_date,
            link: this.link,
            notify_payee: this.notify_payee
        }
    };

    /**
     * @memberof PayoutLink
     * @type Setter Method
     * @takes PayoutLink Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };

    /**
     * @memberof PayoutLink
     * @type Setter Method
     * @takes PayoutLink Params
     * @returns void
     */
    reset = () => {
        this.id = undefined;
        this.merchant = undefined;
        this.unique_code = undefined;
        this.status = undefined;
        this.amount = undefined;
        this.description = undefined;
        this.source = undefined;
        this.payee_name = undefined;
        this.payee_email = undefined;
        this.payee_phone = undefined;
        // this.skip_authentication = undefined;
        // this.authentication_key = undefined;
        this.allowed_beneficiary_types = undefined;
        this.expiry_date = undefined;
        this.link = undefined;
        this.notify_payee = undefined;
    };
}